import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InactivityControlService {
  pauseInactivityModal$ = new BehaviorSubject<boolean>(false);
}